import {styled} from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import {Search} from '@mui/icons-material'

export const StyledSearchField = styled(TextField)(() => ({
  width: 340
}))

export const StyledSearchIcon = styled(Search)(({theme}) => ({
  fontSize: theme.typography.h6.fontSize
}))
